import { ROUTES } from '@/routes/paths';

// Заголовок вкладки по разделу: первый подошедший путь, поэтому вложенные разделы стоят раньше общих. Главные страницы
// кабинетов сверяются точно, иначе они подошли бы любой своей подстранице.
const TITLES: readonly (readonly [string, string])[] = [
  [ROUTES.APP_CARRIER_NEW, 'app.nav.carrierNew'],
  [ROUTES.APP_CARRIER_IN_WORK, 'app.nav.carrierInWork'],
  [ROUTES.APP_CARRIER_DONE, 'app.nav.carrierDone'],
  [ROUTES.APP_AGENT_DASHBOARD, 'app.nav.market'],
  [ROUTES.APP_BEST_PRICE, 'app.nav.bestPrice'],
  [ROUTES.APP_BUY, 'app.nav.buy'],
  [ROUTES.APP_SELL, 'app.nav.sell'],
  [ROUTES.APP_DEALS, 'app.nav.deals'],
  [ROUTES.APP_CHAT, 'app.nav.chat'],
  [ROUTES.APP_COMPANY, 'app.account.company'],
  [ROUTES.APP_PROFILE, 'app.account.profile'],
  [ROUTES.APP_AUDIT, 'app.account.audit'],
  [ROUTES.LOGIN, 'auth.login.title'],
  [ROUTES.REGISTER, 'auth.register.title'],
  [ROUTES.FORGOT_PASSWORD, 'auth.forgotPassword.title'],
  [ROUTES.ABOUT, 'nav.about'],
  [ROUTES.TERMS, 'static.terms.title'],
  [ROUTES.SUPPLY, 'static.supply.title'],
  [ROUTES.TEO, 'static.teo.title'],
  [ROUTES.POLICY, 'static.policy.title'],
  [ROUTES.NOT_FOUND, 'notFound.title'],
];

/** Ключ перевода заголовка раздела; undefined — у страницы своего заголовка нет. */
export function pageTitleKey(pathname: string): string | undefined {
  if (pathname === ROUTES.APP || pathname === ROUTES.APP_CARRIER) {
    return 'app.nav.home';
  }
  return TITLES.find(([path]) => pathname === path || pathname.startsWith(`${path}/`))?.[1];
}
